module.exports = __webpack_public_path__ + "img/corehcms_dashboard3.100efcc6.png";